import React from 'react';
import { useTranslation } from 'react-i18next';

interface RequestCommentsContainerProps {
  comment: string;
  readOnly: boolean;
  onChange?: (value: string) => void;
}

const RequestCommentsContainer: React.FC<RequestCommentsContainerProps> = ({ comment, readOnly, onChange }) => {
  const { t } = useTranslation();

  return (
    <div className="p-4">
      <div className="mb-3">
        <label className="block text-sm text-gray-700 mb-1">{t('Comments')}</label>
        <textarea
          className="w-full p-2 border border-gray-300 rounded"
          onChange={e => onChange(e.target.value as string)}
          value={comment}
          placeholder="Comments"
          rows={4}
          disabled={readOnly}
        />
      </div>
    </div>
  );
};

export default RequestCommentsContainer;
